export default __webpack_public_path__ + "static/media/game.d99eaf57.svg";